module.exports = __webpack_public_path__ + "img/h数据指标.8dace0a0.svg";